import { render, staticRenderFns } from "./Footerr.vue?vue&type=template&id=1637705e&class=temp-footer&"
import script from "./Footerr.vue?vue&type=script&lang=js&"
export * from "./Footerr.vue?vue&type=script&lang=js&"
import style0 from "./Footerr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports